<template>
    <div id="operations_filter"
        style="display: flex; justify-content: space-between;">
        <div> </div>
        <div class="ui segment"
            :style="{
                width: (true) ? '100%' : 'auto',
                margin: 0
            }"
            >
            <!-- Filter -->
            <Header
                class="right floated"
            ></Header>
        </div>
    </div>
</template>

<script>
import Header from "./header.vue"

export default {
    name: "DriverCommissionsFilter",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.driver_commissions_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        Header
    }
}
</script>
